import type { LoginResponse } from "@dotcom/oauthjs";
import { login } from "@dotcom/oauthjs";
import { oauthConfig } from "../config/oauthConfig";

export const authInfo = (async (): Promise<LoginResponse> => {
  const response = await login(oauthConfig);
  if (response?.redirectedFrom) {
    window.location.replace(response?.redirectedFrom);
    throw new Error();
  } else {
    return response;
  }
})();
